<ng-container *ngIf="showGoogleChart">
  <google-chart #googleChart [data]="pieChartData"></google-chart>
</ng-container>
